<div class="mb-2">
    <card-midia
        [file]="midia"
        [content_type]="content_type"
        [obj_referencia]="obj_referencia"
        (changeMidia)="onChangeMidia()"
    ></card-midia>
</div>
